import { render, staticRenderFns } from "./VisorDates.vue?vue&type=template&id=a5874248&scoped=true"
import script from "./VisorDates.vue?vue&type=script&lang=js"
export * from "./VisorDates.vue?vue&type=script&lang=js"
import style0 from "./VisorDates.vue?vue&type=style&index=0&id=a5874248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5874248",
  null
  
)

export default component.exports